import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import queryString from 'query-string';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faArrowCircleRight,
  faArrowCircleLeft,
} from '@fortawesome/pro-regular-svg-icons';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { primaryColor, blackColor } from '../theme/theme';
import container from '../theme/styles/container';
import section from '../theme/styles/section';
import resource from '../theme/styles/resource';
import Link from './Link';

const styles = theme => ({
  ...container,
  ...section,
  ...resource,
  pager: {
    paddingTop: theme.spacing.unit * 4,
  },
  pageNumbersContainer: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  pageNumbers: {
    padding: 0,
    margin: 0,
    listStyleType: 'none',
    textAlign: 'center',
  },
  pagerItem: {
    display: 'inline-block',
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  pagerLink: {
    color: primaryColor,
    textDecoration: 'none',
    fontWeight: 700,

    '&:hover, &:focus': {
      textDecoration: 'underline',
    },
  },
  active: {
    color: blackColor,
    pointerEvents: 'none',
  },
  nextLink: {
    textAlign: 'right',
  },
});

const ResourcePager = ({ classes, resources, qs, articlesPerPage }) => {
  const currentPage = parseInt(qs.page, 10) || 1;
  const numPages = Math.ceil(resources.length / articlesPerPage);
  const isFirst = currentPage === 1;
  const isLast = currentPage === numPages;
  const basePath = '/resources/';

  const pageQueryString = page => ({
    ...qs,
    page,
  });

  return (
    <Grid container spacing={24} className={classes.pager}>
      <Grid item xs={6} sm={3} className={classes.prevLink}>
        {!isFirst && (
          <Link
            to={`${basePath}?${queryString.stringify(
              pageQueryString(currentPage - 1),
            )}`}
            rel="prev"
            className={classes.pagerLink}
          >
            <FontAwesomeIcon icon={faArrowCircleLeft} /> Previous Page
          </Link>
        )}
      </Grid>
      <Grid item sm={6} className={classes.pageNumbersContainer}>
        <ul className={classes.pageNumbers}>
          {Array.from({ length: numPages }, (_, i) => (
            <li key={`pagination-number${i + 1}`} className={classes.pagerItem}>
              <Link
                to={`${basePath}?${queryString.stringify(
                  pageQueryString(i + 1),
                )}`}
                className={classNames(
                  classes.pagerLink,
                  i + 1 === currentPage ? classes.active : '',
                )}
              >
                {i + 1}
              </Link>
            </li>
          ))}
        </ul>
      </Grid>
      <Grid item xs={6} sm={3} className={classes.nextLink}>
        {!isLast && (
          <Link
            to={`${basePath}?${queryString.stringify(
              pageQueryString(currentPage + 1),
            )}`}
            rel="next"
            className={classes.pagerLink}
          >
            Next Page <FontAwesomeIcon icon={faArrowCircleRight} />
          </Link>
        )}
      </Grid>
    </Grid>
  );
};

ResourcePager.propTypes = {
  resources: PropTypes.array.isRequired,
  articlesPerPage: PropTypes.number.isRequired,
  qs: PropTypes.object,
};

export default withStyles(styles)(ResourcePager);
